import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { reset, Field, reduxForm, change } from 'redux-form';
import _ from "lodash" // Import the entire lodash library
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

//material ui
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

//engage components
import {
    renderTextField,
    renderSwitchWithLabel,
} from '../../utils/engageComponents';

//Actions
import { SetHeaderButtons } from '../../actions/headerButtonsActions';

import { GetApps, } from '../../actions/appsActions';
import { GetGroups, AddGroup, UpdateGroup, UpdateGroupsOrder } from '../../actions/groupAppsActions';
import { IconsModal } from '../scheduler/IconsModal';
import TranslationField from "./TranslationField";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3} style={{ padding: '0px', margin: '0px' }}>
                    <Grid >{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const validate = (values) => {
    const errors = {};

    if (!values.Name) {
        errors.Name = 'Please enter a Name';
    }

    return errors;
};

class AppsGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            communityId: localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined,

            //Details Modal
            elementForDetail: undefined,

            activeStep: 0,
            openGroupModalDetails: false,
            openIconResourceNameSelect: false,
            newAppsData: undefined,
            optionIconsSelected: undefined,
            shouldUpdate: false,
            newElementActiveSatus: true,
            openSelectIconModal: false,

            //trasnlation
            isTranslationEnabled: false,
            translationData: [{ languageCode: 'es', fieldLabel: 'Nombre', }, { languageCode: 'fr', fieldLabel: 'Nom' }],

        };
    }


    async componentDidMount() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
        this.SetHeaderButtons();

        if (communityId) {
            this.props.GetGroups(communityId)
            this.props.GetApps(communityId);
        }
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    //MODAL
    IconResourceNameComponentOnChangeHandler = (e, newItem) => {

        this.setState({ optionIconsSelected: { ...newItem, categoryColor: '#949494' } });

        this.props.dispatch(change('AppGroupsForm', 'IconResourceObject', newItem.name));
        this.props.dispatch(change('AppGroupsForm', 'detailIconUrl', (newItem && newItem.iconUrl) ? newItem.iconUrl : ''));

        this.handleCategoryCombo(null, false);
    };

    handleCategoryCombo = (e, option) => {
        if (!option) {
            this.setState((prevState) => ({ openIconResourceNameSelect: !prevState.openIconResourceNameSelect }));
        } else {
            this.setState({ openIconResourceNameSelect: option });
        }
    }

    onBlurIconResourceNameComponentHandler = () => {
        this.setState({ openIconResourceNameSelect: false });
    }

    //SUBMIT
    onSubmitHandler = async (values) => {

        if (this.state && this.state.elementForDetail) {
            //update
            this.UpdateGroup(values);
        } else {
            //Add
            this.AddGroup(values)
        }

    };

    AddGroup = async (values) => {
        try {
            let groupToSave = {};

            let name = (values.Name) ? values.Name : '';
            let iconResourceName = (this.state && this.state.optionIconsSelected) ? this.GetIconResourceName(this.state.optionIconsSelected) : '';
            let iconUrl = (values.detailIconUrl) ? values.detailIconUrl : '';
            let groupCommunities = [];

            groupCommunities = this.GetInitialCommunities();

            if (
                !values ||
                !name ||
                !iconResourceName ||
                !iconUrl ||
                !groupCommunities
            )
                return;

            groupToSave = {
                name: name,
                iconResourceName: iconResourceName,
                iconUrl: iconUrl,
                groupCommunities: groupCommunities,
                translations: this.state.translationData ? this.state.translationData.map(t => ({ languageCode: t.languageCode, name: t.name })) : [],
            };

            await this.props.AddGroup(groupToSave);
            await this.props.GetGroups()
            await this.props.GetApps()
            this.closeModal();

        } catch (err) { }
    };

    UpdateGroup = async (values) => {

        if (!this.state.elementForDetail) return;

        const communityId = (this.state.communityId) ? this.state.communityId : undefined;
        const newElement = _.cloneDeep(this.state.elementForDetail);
        const newAppsData = _.cloneDeep(this.state.newAppsData);

        if (!newAppsData || !newElement || !communityId) return;

        let elementCommunity = newElement.groupCommunities.find(community => community.communityId === communityId);
        const appsInCommunity = elementCommunity.apps;


        if (this.state.newGroupsAppData && this.state.newGroupsAppData.length > 0) {
            const groupFound = this.state.newGroupsAppData.find(group => group._id === this.state.elementForDetail._id);
            if (groupFound && groupFound.groupCommunities && groupFound.groupCommunities.length > 0) {
                elementCommunity.active = (groupFound.groupCommunities[0].active) ? groupFound.groupCommunities[0].active : false;
            }
        }
        for (let i = 0; i < appsInCommunity.length; i++) {
            let currentApp = appsInCommunity[i];
            const appFound = newAppsData.find(app => app._id === currentApp.appId);

            if (!appFound || !appFound.appCommunities) continue;

            currentApp.active = appFound.appCommunities[0].active;
        }

        const appToAdd = newAppsData.filter(newApp => !appsInCommunity.find(app => app.appId === newApp._id));

        if (appToAdd.length > 0)
            for (let i = 0; i < appToAdd.length; i++) {
                let baseApp = appToAdd[i];

                const communityObj = (baseApp && baseApp.appCommunities) ? baseApp.appCommunities.find(comm => comm.communityId === communityId) : undefined;
                const isAppActive = (communityObj && communityObj.active) ? communityObj.active : false;


                let appToPush = {
                    appId: (baseApp && baseApp._id) ? baseApp._id : '',
                    appName: (baseApp && baseApp.name) ? baseApp.name : '',
                    active: (isAppActive) ? isAppActive : false,

                }

                appsInCommunity.push(appToPush);
            }


        //new Apps Order for current communty

        for (let i = 0; i < appsInCommunity.length; i++) {
            const currentAppInCommunity = appsInCommunity[i];

            if (!currentAppInCommunity) continue;

            const appFoundInNewAppsData = newAppsData.find(app => app._id === currentAppInCommunity.appId);

            if (!appFoundInNewAppsData || !appFoundInNewAppsData.appCommunities || appFoundInNewAppsData.appCommunities.length === 0) continue;
            const appCommunity = appFoundInNewAppsData.appCommunities.find(comm => comm.communityId === communityId);

            const appOrder = (appCommunity && appCommunity.appOrder > -1) ? appCommunity.appOrder : undefined;

            currentAppInCommunity.appOrder = appOrder;

        }

        newElement.name = (values && values.Name) ? values.Name : newElement.name;
        newElement.iconResourceName = (this.state && this.state.optionIconsSelected) ? this.GetIconResourceName(this.state.optionIconsSelected) : newElement.iconResourceName;
        newElement.iconUrl = (this.state && this.state.optionIconsSelected) ? this.state.optionIconsSelected.iconUrl : newElement.iconUrl;
        newElement.translations = (this.state.translationData) ? this.state.translationData.map(t => ({ languageCode: t.languageCode, name: t.name })) : [];

        let oldGroup = this.props.groupsData.find(group => group._id === this.state.elementForDetail._id);

        if (oldGroup && oldGroup.groupCommunities) {
            oldGroup = _.cloneDeep(oldGroup);
            let oldGroupCommunities = oldGroup.groupCommunities;

            const communityExist = (oldGroupCommunities && oldGroupCommunities.length > 0) ? oldGroupCommunities.find(comm => comm.communityId === communityId) : undefined;
            const isNewCommunity = (!communityExist) ? true : false;
            newElement.groupCommunities = oldGroupCommunities.map(comm => (comm.communityId === communityId) ? elementCommunity : comm);

            if (isNewCommunity) {
                newElement.groupCommunities = [...newElement.groupCommunities, elementCommunity]
            }
        }

        if (this.props.UpdateGroup)
            await this.props.UpdateGroup(newElement._id, newElement);

        await this.props.GetGroups()

        this.closeModal()

    };

    updateGroupStatus = async (groupId, newStatus) => {
        try {
            const communityId = this.state.communityId ? this.state.communityId : undefined;

            if (!groupId || !this.props.groupsData || !communityId) return undefined

            const groupFound = this.props.groupsData.find(group => group._id === groupId);

            if (!groupFound) return undefined;

            let oldGroup = this.props.groupsData.find(group => group._id === groupId);

            if (oldGroup && oldGroup.groupCommunities) {
                oldGroup = _.cloneDeep(oldGroup);
                let oldGroupCommunities = oldGroup.groupCommunities;
                oldGroup.groupCommunities = oldGroupCommunities.map(comm => comm.communityId === communityId ? { ...comm, active: newStatus } : comm);

                const communityExist = oldGroup.groupCommunities.find(comm => comm.communityId === communityId);
                const groupToUpdate = this.state.newGroupsAppData.find(group => group._id === groupId);
                const newCommunity = groupToUpdate.groupCommunities.find(comm => comm.communityId === communityId);

                if (!communityExist && newCommunity) {
                    oldGroup.groupCommunities = [...oldGroup.groupCommunities, { ...newCommunity, active: newStatus }]
                }
            }

            if (this.props.UpdateGroup && oldGroup) {
                await this.props.UpdateGroup(groupId, oldGroup);
            }

            await this.props.GetGroups();
            this.closeModal();

        } catch (err) {
        }
    }

    GetInitialCommunities = () => {
        try {
            const communityId = this.state.communityId ? this.state.communityId : undefined;

            if (!communityId || !this.props.communityData || !this.props.communityData.length > 0) return [];

            const communitiesData = this.props.communityData ? this.props.communityData : undefined;
            const communityFound = communitiesData.find(community => community.communityId === communityId);

            if (!communityFound) return;

            let arrayCommunities = [];
            let appsArray = [];
            let existentApps = this.state.newAppsData ? this.state.newAppsData : [];

            for (let i = 0; i < communitiesData.length; i++) {
                const currentCommunity = communitiesData[i];

                appsArray = existentApps.map(app => {
                    let newAppOrder = undefined;
                    const appCommunity = (app && app.appCommunities) ? app.appCommunities.find(comm => comm.communityId === communityId) : undefined;

                    if (appCommunity && appCommunity.appOrder > -1 && currentCommunity.communityId === communityId) {
                        newAppOrder = appCommunity.appOrder;
                    }

                    return ({
                        appName: app.name,
                        appId: app._id,
                        appOrder: newAppOrder > -1 ? newAppOrder : undefined,
                        active: this.GetAppStatus(app, currentCommunity.communityId === communityId)
                    })
                }
                );

                let communityObject = {
                    communityId: currentCommunity.communityId ? currentCommunity.communityId : '',
                    communityName: currentCommunity.communityName ? currentCommunity.communityName : '',
                    apps: appsArray,
                    active: (this.state.newElementActiveSatus) ? this.state.newElementActiveSatus : false,
                };

                arrayCommunities.push(communityObject);
            };

            return arrayCommunities;
        } catch (err) { }
    };

    GetAppStatus = (app, isSelectedCommunity) => {

        if (isSelectedCommunity && app && app.appCommunities && app.appCommunities.length > 0) {

            const isActive = app.appCommunities[0].active;

            return isActive;
        }

        return false;
    };

    GetIconResourceName = (optionSelected) => {
        if (!optionSelected && !optionSelected.name)
            return undefined

        const regEx1 = new RegExp('-', "g");
        const regEx2 = new RegExp(' ', "g");

        let newName = optionSelected.name ? optionSelected.name.replace(regEx1, '_').replace(regEx2, '_') : undefined;
        newName = `ic_${newName}`;

        return newName;
    };

    cleanDetailsModal = () => {
        this.setState({
            openIconResourceNameSelect: false,
            optionIconsSelected: undefined,
            activeStep: 0,
            newAppsData: undefined,
            newElementActiveSatus: true,
            isTranslationEnabled: false,
            translationData: [{ languageCode: 'es', fieldLabel: 'Nombre', }, { languageCode: 'fr', fieldLabel: 'Nom' }],
        });

        this.props.dispatch(reset('AppGroupsForm'));

    };

    closeModal = () => {
        this.cleanDetailsModal();
        this.setState({ openGroupModalDetails: false, elementForDetail: undefined, shouldUpdate: true });
    };


    //HEADER BUTTONS
    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = () => {
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledDeleteButton: {
                backgroundColor: 'white'
            },
            disabledButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: 'white',
                color: '#686868 ',
                pointerEvents: 'none',
            },
            skyBlueButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                cursor: 'pointer',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                color: '#ffffff',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: '#009EDD',
            },
        }


        return (
            <Grid container style={styles.globalActions} >
                <div className="appbtn-list-engage" style={styles.globalActions}>
                    <div id='add_dining_save_btn' className="blueBottomButon appbtnBarButton" onClick={() => this.newGroup()}>
                        Add Group
                    </div>
                </div>
            </Grid>
        )
    };

    newGroup = () => {

        if (this.props && this.props.newAppsData && this.props.newAppsData.length > 0 && !this.state.newAppsData) {
            let stateApps = _.cloneDeep(this.props.newAppsData);
            const initialSwitchValue = this.GetSwitchStatus(stateApps);

            this.setState({ newAppsData: stateApps, switchAllCommunitiesSelected: initialSwitchValue })
        }
        this.setState((prevState) => ({ openGroupModalDetails: true }))
    };

    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 8 * 2,
        margin: `0 0 ${8}px 0`,

        // change background colour if dragging
        background: isDragging ? "lightgreen" : "grey",

        // styles we need to apply on draggables
        ...draggableStyle
    });

    getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "lightblue" : "lightgrey",
        padding: 8,
        width: 250
    });

    //
    ElementComponent = ({ element, isGroup }) => {

        if (!element)
            return <Grid></Grid>;

        const styles = {
            element: {
                padding: '10px',
            },
            card: {
                borderRadius: '16px',
                backgroundColor: "#92949c",
                minHeight: '150px',
                color: '#686868',
            },
            image: {
                width: '60px',
                height: '60px',
            },
            content: {
                height: '60%',
                padding: '10px',
            },
            checkBox: {
                padding: '10px',
                height: '40%',
                backgroundColor: '#000000',
                borderBottomLeftRadius: '16px',
                borderBottomRightRadius: '16px'
            }
        }

        let clickHandler = undefined;
        const groupClickHandler = () => this.PopulateGroupModal(element)

        const appClickHandler = () => {
        }

        if (isGroup) {
            clickHandler = groupClickHandler;
        } else {
            clickHandler = appClickHandler;
        }

        return (
            <Grid item container style={styles.element}>
                <Grid item container justify="center" alignContent="center" style={styles.card} onClick={clickHandler} >
                    <Grid item container alignContent='center' justify="center" style={styles.content} >
                        {
                            (element.iconUrl) ?
                                <Grid item container style={styles.image}>
                                    <img src={element.iconUrl} alt={`${element.name}`} style={styles.image} />
                                </Grid>
                                :
                                this.GetElementBadge(element)
                        }
                    </Grid>
                    <Grid item container style={styles.checkBox}>
                        <Grid item container justify="center" alignContent="center" style={{}}>
                            <this.GetCheckboxElement element={element} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    PopulateGroupModal = (element) => {

        const communityId = (this.state || this.state.communityId) ? this.state.communityId : undefined;
        if (!element || !element.groupCommunities || !communityId) return undefined;

        const communityFound = element.groupCommunities.find(community => community.communityId === communityId);

        if (!communityFound || !communityFound.apps) return undefined;

        const apps = communityFound.apps;

        let newAppsData = (this.props && this.props.newAppsData) ? _.cloneDeep(this.props.newAppsData) : undefined;

        if (!newAppsData) return undefined;



        for (let i = 0; i < newAppsData.length; i++) {
            const currentApp = newAppsData[i];
            const appFound = apps.find(app => app.appId === currentApp._id);


            if (!appFound || !currentApp || !currentApp.appCommunities || !currentApp.appCommunities.length > 0) continue;

            currentApp.appCommunities[0].active = appFound.active;
            currentApp.appOrder = appFound.appOrder;

        }

        newAppsData = newAppsData.sort((a, b) => a.appOrder > b.appOrder)

        let iconFound = this.GetIconResourceByUrl(element.iconUrl);
        iconFound = { ...iconFound, categoryColor: '#949494' }

        this.props.dispatch(change('AppGroupsForm', 'Name', element.name));
        this.props.dispatch(change('AppGroupsForm', 'IconResourceObject', iconFound.name));
        this.props.dispatch(change('AppGroupsForm', 'detailIconUrl', iconFound.iconUrl));

        if (element && element.translations && element.translations.length > 0) {
            const translationsWithData = element.translations.some(t => (t.name && t.name.length > 0))

            if (translationsWithData)
                this.setState({ isTranslationEnabled: true, translationData: element.translations })
        }


        this.setState({ newAppsData: newAppsData, openGroupModalDetails: true, optionIconsSelected: iconFound, elementForDetail: element })
    }

    GetIconResourceByUrl = (iconUrl) => {
        try {
            if (!iconUrl && !this.props && !this.props.IconsData) return undefined;

            const objectFound = this.props.IconsData ? this.props.IconsData.find(icon => icon.iconUrl === iconUrl) : undefined;

            if (!objectFound) return undefined;

            return objectFound;
        } catch (err) { }
    }

    GetCheckboxElement = ({ element }) => {
        if (!element)
            return <Grid></Grid>;


        const groupCommunities = (element && element.groupCommunities && element.groupCommunities.length > 0) ? element.groupCommunities[0] : undefined;
        const appCommunities = (element && element.appCommunities && element.appCommunities.length > 0) ? element.appCommunities[0] : undefined;

        const communities = groupCommunities ? groupCommunities : appCommunities;

        if (!communities)
            return <Grid></Grid>;

        const isChecked = (communities.active) ? communities.active : false;

        let handleClick = undefined;

        if (groupCommunities) {
            handleClick = this.groupCheckBoxClickHandler;
        } else {
            handleClick = this.handleCheckBoxClick;
        }
        return (
            <Grid item container justify="center" alignContent="center" >
                <Grid item xs={4} style={{}} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        id={`checkbox_${element._id}`}
                        checked={isChecked}
                        onChange={(e) => handleClick(element._id)}
                        name={`checkBox_${element._id}`}
                        className={isChecked ? 'isChecked' : ''}
                    />
                </Grid>
                <Grid item container xs={8} alignContent="center" justify="flex-start" style={{ display: 'flex', alignItems: 'center', paddingLeft: '5px' }}>
                    <Grid item className="EllipsisItem">
                        {(element && element.name) ? element.name : ''}
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    GetElementBadge = (element) => {
        const styles = {
            container: {
                padding: '10px'
            },
            badge: {
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: "#92949c",
                fontSize: '25px'
            }
        }

        const initials = (element && element.name) ? element.name.split(' ').map(word => word[0].toUpperCase()) : '';

        return (
            <Grid item container justify='center' alignContent="center" style={styles.badge}>
                <Grid item >
                    {initials}
                </Grid>
            </Grid>
        )
    };

    GetSwitchStatus = (newAppsData) => {

        if (!newAppsData)
            return false;

        let initialSwitchValue = true;

        for (let i = 0; i < newAppsData.length; i++) {
            const currentApp = newAppsData[i];

            const appCommunities = (currentApp && currentApp.appCommunities && currentApp.appCommunities.length > 0) ? currentApp.appCommunities[0] : undefined;

            if (!appCommunities)
                break;

            initialSwitchValue = appCommunities.active;

            if (!initialSwitchValue)
                break;
        }

        return initialSwitchValue;
    };

    handleCheckBoxClick = async (_id) => {
        if (!_id)
            return false;

        const oldApps = (this.state && this.state.newAppsData) ? this.state.newAppsData : [];

        let elementFound = (this.state && this.state.newAppsData) ? this.state.newAppsData.find(element => (element._id === _id)) : undefined;

        if (!elementFound || !elementFound.appCommunities)
            return false

        elementFound = { ...elementFound };
        const community = elementFound.appCommunities[0]

        if (!community)
            return false;

        community.active = !community.active;

        let appToUpdate = (this.props && this.props.appsData) ? this.props.appsData.find(app => app._id === _id) : undefined;

        const newApps = oldApps.map(element => (element._id === _id) ? elementFound : element)

        const switchValue = this.GetSwitchStatus(this.state.newAppsData)

        this.setState({ newAppsData: newApps, switchAllCommunitiesSelected: switchValue });

        if (appToUpdate) {
            const appCommunities = (appToUpdate && appToUpdate.appCommunities) ? appToUpdate.appCommunities : [];

            const communityFound = (elementFound && elementFound.appCommunities) ? elementFound.appCommunities[0] : undefined;

            let communityObject = appCommunities.find(community => community.communityId === communityFound.communityId);

            if (communityObject) {
                communityObject = _.cloneDeep(communityObject);
                communityObject.active = !communityObject.active;
                const newCommunityObject = appCommunities.map(community => community.communityId === communityFound.communityId ? communityObject : community);

                appToUpdate.appCommunities = newCommunityObject;

                if (this.props.UpdateApp) {
                    await this.props.UpdateApp(appToUpdate._id, appToUpdate);

                    if (this.state && this.state.communityId)
                        this.props.GetApps(this.state.communityId);
                }
            }
        }
    };

    groupCheckBoxClickHandler = async (groupId) => {
        try {
            const communityId = this.state.communityId ? this.state.communityId : undefined;
            if (!groupId || !this.state.newGroupsAppData || this.state.newGroupsAppData.length < 1 || !communityId) return undefined;

            const groupFound = this.state.newGroupsAppData.find(group => group._id === groupId);

            if (!groupFound) return undefined;

            let groupCommunities = groupFound.groupCommunities ? groupFound.groupCommunities : undefined;

            let communityObject = groupCommunities.find(comm => comm.communityId === communityId)

            communityObject.active = !communityObject.active;

            const updatedNewGroupsAppData = this.state.newGroupsAppData.filter(group => group._id === groupId ? groupFound : group);

            this.updateGroupStatus(groupId, communityObject.active)
            this.setState({ newGroupsAppData: updatedNewGroupsAppData, shouldUpdate: true })

        } catch (err) { return undefined }
    }

    handleTabChange = (e, step) => {
        this.setState({ activeStep: step })
    };

    reorderElements = (result) => {
        try {

            const communityId = this.state.communityId ? this.state.communityId : undefined;
            const { source, destination } = result;


            const isActiveApps = source.droppableId === 'enabled_Droppable' ? true : false;

            if (!destination || !communityId) return undefined;

            const apps = _.cloneDeep(this.state.newAppsData).filter(app => app.appCommunities[0].active === isActiveApps);
            const allApps = _.cloneDeep(this.state.newAppsData);

            if (!apps || apps.length < source.index) return undefined;
            const appInSource = apps[source.index];
            const appInDestination = apps[destination.index];

            if (!appInSource || !appInDestination) return undefined;

            const sourceIndexInAllAppsArray = allApps.findIndex((element) => element._id === appInSource._id);
            const destinationIndexInAllAppsArray = allApps.findIndex((element) => element._id === appInDestination._id);

            const sourceOutsideAllApps = allApps.splice(sourceIndexInAllAppsArray, 1);
            allApps.splice(destinationIndexInAllAppsArray, 0, ...sourceOutsideAllApps);

            for (let i = 0; i < allApps.length; i++) {
                const currentApp = allApps[i];
                const communityObj = currentApp.appCommunities.find(comm => comm.communityId === communityId);

                if (!communityObj) continue;

                communityObj.appOrder = i;

                currentApp.appCommunities = currentApp.appCommunities.map(comm => comm._id === communityId ? communityObj : comm)
            }

            this.setState({ newAppsData: allApps })

        } catch (err) { return undefined; }
    };

    reorderGroups = (result) => {
        try {

            const communityId = this.state.communityId ? this.state.communityId : undefined;
            const { source, destination } = result;

            if (!destination || !communityId) return undefined;

            let newGroups = _.cloneDeep(this.state.newGroupsAppData);

            const groupFound = newGroups[source.index];

            const sourceObjInNewGroups = newGroups.findIndex((element) => element._id === groupFound._id);

            const sourceOutsideAllNewGroups = newGroups.splice(sourceObjInNewGroups, 1);

            newGroups.splice(destination.index, 0, ...sourceOutsideAllNewGroups);

            for (let i = 0; i < newGroups.length; i++) {
                let currentGroup = newGroups[i];

                const communityObj = (currentGroup && currentGroup.groupCommunities && currentGroup.groupCommunities.length > 0) ? currentGroup.groupCommunities.find(comm => comm.communityId === communityId) : undefined;

                communityObj.groupOrder = i;
                currentGroup.groupCommunities = currentGroup.groupCommunities.map(comm => (comm.communityId === communityId) ? communityObj : comm);
            }

            this.setState({ newGroupsAppData: newGroups })

            this.updateGroupsOrder(newGroups);

        } catch (err) { return undefined; }
    };

    updateGroupsOrder = async (newGroups) => {
        try {
            const communityId = this.state.communityId ? this.state.communityId : undefined;
            if (!newGroups || newGroups.length === 0 || !communityId) return undefined;

            let updateGroups = _.cloneDeep(newGroups);

            let groupIds = [];
            for (let i = 0; i < updateGroups.length; i++) {
                const currentGroup = updateGroups[i];
                const groupId = currentGroup._id;
                const groupObj = (currentGroup && currentGroup.groupCommunities && currentGroup.groupCommunities.length > 0) ? currentGroup.groupCommunities.find(comm => comm.communityId === communityId) : undefined
                const groupOrder = (groupObj && groupObj.groupOrder > -1) ? groupObj.groupOrder : undefined;


                if (!groupId || !groupOrder < 0) continue;

                groupIds.push({
                    groupId: groupId,
                    groupOrder: groupOrder,
                })
            }

            await this.props.UpdateGroupsOrder(communityId, groupIds);
            await this.props.GetGroups()

        } catch (err) {
            return undefined;
        }
    }

    DnD = ({ baseName = undefined, enabledApps = undefined }) => {
        try {

            if (!baseName || !enabledApps || (enabledApps.toLowerCase() !== 'enabled' && enabledApps.toLowerCase() !== 'disabled')) return <Grid item container></Grid>

            const appsToRender =
                (this.state && this.state.newAppsData && this.state.newAppsData.length > 0 && this.state.newAppsData.filter(app => app.appCommunities[0].active === (enabledApps && enabledApps === 'enabled') ? true : false).length > 0) ?
                    this.state.newAppsData.filter(app => app.appCommunities[0].active === (enabledApps && enabledApps === 'enabled') ? true : false) :
                    undefined;


            if (!appsToRender)
                return <Grid item container justify="center" alignContent="center" style={{ color: '#686868', fontSize: '16px' }}>
                    <Grid item>
                        No Apps Found!
                    </Grid>
                </Grid>

            //this.reorderElements(result)} style={{width:'100%'}}
            return (
                <DragDropContext onDragEnd={(result) => this.reorderElements(result)} >
                    <Droppable droppableId={`${baseName}_Droppable`} direction='horizontal'>
                        {(provided,) => (
                            <Grid
                                item container
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {
                                    appsToRender.map((element, index) => (
                                        <Draggable key={element._id} draggableId={element._id} index={index} id={`${baseName}_DraggableComponent_${element._id}`} className='Draggable' >
                                            {(provided,) => (
                                                <Grid
                                                    id='refGrid'
                                                    className='Draggable'
                                                    item container
                                                    sm={12}
                                                    md={6}
                                                    lg={4}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <this.ElementComponent element={element} isGroup={false} />
                                                </Grid>

                                            )}
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </Grid>
                        )}
                    </Droppable>
                </DragDropContext>
            )


        } catch (err) {
            return <Grid item container> </Grid>
        }
    };

    GroupDnD = () => {
        try {
            const appsToRender = (this.state.newGroupsAppData && this.state.newGroupsAppData.length > 0) ? this.state.newGroupsAppData : [];

            if (appsToRender.length === 0)
                return (
                    <Grid item container justify="center" alignContent="center" style={{ heigth: '100%' }}>
                        <Grid item style={{}}> No information found!</Grid>
                    </Grid>
                )

            return (
                <DragDropContext onDragEnd={(result) => this.reorderGroups(result)} >
                    <Droppable droppableId={`Group_Droppable`} direction='horizontal'>
                        {(provided,) => (
                            <Grid
                                item container
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {
                                    appsToRender.map((element, index) => (
                                        <Draggable key={element._id} draggableId={element._id} index={index} id={`Group_DraggableComponent_${element._id}`} className='Draggable' >
                                            {(provided,) => (
                                                <Grid
                                                    id='refGrid'
                                                    className='Draggable'
                                                    item container
                                                    xs={12}
                                                    sm={6}
                                                    md={4}
                                                    lg={3}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <this.ElementComponent element={element} isGroup={true} />
                                                </Grid>

                                            )}
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </Grid>
                        )}
                    </Droppable>
                </DragDropContext>
            )
        } catch (err) {
            return <Grid item container> </Grid>
        }
    }

    handleClickOnDetailsModal = (elementId) => {
        try {
            const communityId = this.state.communityId ? this.state.communityId : undefined;

            if (!elementId && !this.state.elementForDetail) {
                //New Group
                const newElementActiveSatus = (this.state.newElementActiveSatus) ? this.state.newElementActiveSatus : false;

                this.setState({ newElementActiveSatus: !newElementActiveSatus })
            } else {
                //Update Group

                if (!elementId || !this.state.elementForDetail || this.state.elementForDetail._id !== elementId || !communityId) return undefined;

                const element = this.state.elementForDetail;
                const elementCommunity = (element && element.groupCommunities && element.groupCommunities.length > 0) ? element.groupCommunities.find(comm => comm.communityId === communityId) : undefined;

                elementCommunity.active = !elementCommunity.active;

                this.setState({ elementForDetail: element });

            }


        } catch (err) { return undefined }

    }

    handleSelectIcon = (iconSelected) => {

        if (!iconSelected) return undefined;

        this.props.dispatch(change('AppGroupsForm', 'IconResourceObject', iconSelected.name));
        this.props.dispatch(change('AppGroupsForm', 'detailIconUrl', (iconSelected && iconSelected.iconUrl) ? iconSelected.iconUrl : ''));

        this.setState({ optionIconsSelected: iconSelected, openSelectIconModal: false })
    }

    onAddTranslationSwitch = (status = undefined) => {

        if ((status && status === 'false') || status === 'true') {
            this.setState((prevState) => ({ isTranslationEnabled: status }));
        } else {
            this.setState((prevState) => ({ isTranslationEnabled: !prevState.isTranslationEnabled }));
        }
    }

    onChangeHandler = (obj) => {

        if (!obj && !obj.languageCode) return undefined;

        const translationData = this.state.translationData ? this.state.translationData : [];
        let objFound = translationData.find(trasnlation => trasnlation.languageCode === obj.languageCode);

        let newTranslationData = [];
        if (!objFound) {
            objFound.languageCode = obj.languageCode
            objFound.name = obj.value

            newTranslationData = [...translationData, objFound];
        } else {
            objFound.name = obj.value;
            newTranslationData = translationData.map(t => t.languageCode === obj.languageCode ? objFound : t);
        }

        this.setState({ translationData: newTranslationData });
    }

    render() {
        const Height = 650;
        const styles = {
            container: {
                backgroundColor: '#1f1f1f',
                borderRadius: '16px',
                minHeight: '50px',
                width: '100%',
            },
            paperModal: {
                backgroundColor: '#1F1F1F',
                padding: '6px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                width: '45%',
                height: Height + 'px',

            },
            buttonStyle: {
                borderRadius: '25px',
                backgroundColor: '#959494',
                width: '9rem',
                fontSize: '1rem',
                fontWeight: 'bold',
                color: 'white',
                textAlign: 'center',
                textTransform: 'none'
            },
            tabStyles: {
                backgroundColor: '#1f1f1f',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',
            },
            SelectedTabStyle: {
                backgroundColor: '#454446',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',
            },

            DraggableItem: {

            },
        };

        const { handleSubmit } = this.props;

        if ((this.props.newGroupsAppData && this.props.newGroupsAppData.length > 0 && !this.state.newGroupsAppData) || this.state.shouldUpdate) {
            this.setState({ newGroupsAppData: this.props.newGroupsAppData, shouldUpdate: false });
        }

        const elementSelectedForDetails = this.state.elementForDetail;

        let isElementForDetailsActive = false;
        if (elementSelectedForDetails) {
            const elementCommunity = (elementSelectedForDetails && elementSelectedForDetails.groupCommunities && elementSelectedForDetails.groupCommunities.length > 0) ? elementSelectedForDetails.groupCommunities.find(comm => comm.communityId === this.state.communityId) : undefined;
            isElementForDetailsActive = (elementCommunity && elementCommunity.active) ? elementCommunity.active : false;
        } else {
            isElementForDetailsActive = (this.state.newElementActiveSatus) ? this.state.newElementActiveSatus : false;
        }

        return (
            <Grid container style={{ ...styles.container, }}>
                <form style={{ width: '100%', height: '100%', }}>
                    <Grid container justify="center" alignContent="center" xs={12} style={{ width: '100%', height: '100%', }}>
                        <Grid item container justify="center" alignContent="center" xs={12} style={{ width: '100%' }}>
                            <this.GroupDnD />
                        </Grid>
                    </Grid>
                    {
                        (this.state && this.state.openGroupModalDetails) ?
                            <Modal
                                open={this.state.openGroupModalDetails}
                                onClose={this.closeModal}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <Paper className='modalPaperStyles' elevation={3} style={{ ...styles.paperModal }} color='secondary'>
                                    <Grid container justify='center' alignContent='flex-start' style={{ height: (Height) + 'px', padding: '0px', margin: '0px' }}>
                                        {/*title container */}
                                        <Grid item container justify='center' style={{ height: (Height * .15) + 'px', fontSize: '12px' }}>
                                            <Grid item container alignContent='center' justify='flex-start' xs={12} className='TitleRepairsModal' >
                                                <Grid item style={{ height: '20%', }} >
                                                    Group Details
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/*tabs container */}
                                        <Grid item container alignContent='flex-start' justify='center' style={{ height: (Height * .1) + 'px', fontSize: '12px' }}>
                                            <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: '#2a2a2b' }}>
                                                <Tabs
                                                    value={this.state.activeStep}
                                                    onChange={this.handleTabChange}
                                                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                                    variant="fullWidth"
                                                    aria-label="full width tabs community"
                                                >
                                                    <Tab className='setupInfoSection' label="Details" style={(this.state.activeStep === 0) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                                    <Tab className='setupInfoSection' label="Enabled Apps" style={(this.state.activeStep === 1) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />
                                                    <Tab className='setupInfoSection' label="Disabled Apps" style={(this.state.activeStep === 2) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true} />

                                                </Tabs>
                                            </AppBar>
                                        </Grid>
                                        {/* content container */}
                                        <Grid item container alignContent='flex-start' justify='center' style={{ height: (Height * .6) + 'px', fontSize: '12px', overflow: 'auto' }}>
                                            <SwipeableViews
                                                axis={'x' === 'rtl' ? 'x-reverse' : 'x'}
                                                index={this.state.activeStep}
                                                onChangeIndex={this.handleChangeIndex}
                                                style={{ width: '100%', height: (Height * .6) + 'px' }}
                                            >
                                                {/******************************************************** TabPanel Groups **************************************************************/}
                                                <TabPanel id='groupModal_Details' className='setupInfoSection' value={this.state.activeStep} index={0} dir={'x'} style={{ height: (Height * .6) + 'px' }}>
                                                    <Grid item container justify="center" alignContent="center" style={{ height: (Height * .6) + 'px' }}>
                                                        <Grid item container justify="center" alignContent="flex-start" style={{ height: ((Height * .6)) + 'px', padding: '25px 50px' }} >
                                                            <Grid item container justify="center" alignContent="center">
                                                                <Grid item container justify="flex-start" alignContent="center" style={{ width: '100%' }}>
                                                                    <Grid item container xs={12} md={8} lg={8} style={{ fontSize: '25px', color: '#949494' }}>
                                                                        <Grid item container xs={12} md={6} lg={4} alignContent='center' justify="center">
                                                                            <Grid item>
                                                                                Active:
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item container xs={12} md={6} lg={8} alignContent='center' justify="flex-start">
                                                                            <Grid item>
                                                                                <Checkbox
                                                                                    id={`checkbox_InsideModal_${(this.state.elementForDetail && this.state.elementForDetail._id) ? this.state.elementForDetail._id : 'inactive'}`}
                                                                                    checked={isElementForDetailsActive}
                                                                                    onChange={(e) => this.handleClickOnDetailsModal((this.state.elementForDetail && this.state.elementForDetail) ? this.state.elementForDetail._id : undefined)}
                                                                                    name={`checkbox_InsideModal_${(this.state.elementForDetail && this.state.elementForDetail._id) ? this.state.elementForDetail._id : 'inactive'}`}
                                                                                    className={isElementForDetailsActive ? 'isChecked' : ''}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container justify="flex-start" alignContent="center">
                                                                    <Grid item xs={12} md={8} lg={8} style={{ fontSize: '25px', color: '#949494', padding: '5px 0' }}>
                                                                        <Field
                                                                            idToSet='addTranslationsSwitch'
                                                                            name='addTranslationsSwitch'
                                                                            label={'Add translations'}
                                                                            checked={this.state.isTranslationEnabled ? this.state.isTranslationEnabled : false}
                                                                            onClick={this.onAddTranslationSwitch}
                                                                            component={renderSwitchWithLabel}
                                                                            labelInLeft={false}
                                                                            stylesLabel={{}}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                                {
                                                                    (this.state.isTranslationEnabled) ?
                                                                        <TranslationField inputData={this.state.translationData ? this.state.translationData : []} onChangeHandler={this.onChangeHandler} />
                                                                        :
                                                                        <Grid item container></Grid>
                                                                }
                                                                <Grid item container style={{ width: '100%' }}>
                                                                    <Field
                                                                        name="Name"
                                                                        label="Name"
                                                                        maxLength={20}
                                                                        component={renderTextField}
                                                                    />
                                                                </Grid>
                                                                <Grid item container style={{ width: '100%' }}>
                                                                    <Grid item container xs={12} md={6} lg={8}>
                                                                        <Field
                                                                            name="IconResourceObject"
                                                                            label="Icon Resourse Name"
                                                                            maxLength={20}
                                                                            component={renderTextField}
                                                                            disabled={true}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item container xs={12} md={6} lg={4} alignContent='center' justify="center">
                                                                        <Grid item >
                                                                            <Button id='appDetails_save_btn' style={{ ...styles.buttonStyle, backgroundColor: '#009edd', margin: '10px 10px' }} onClick={() => this.setState({ openSelectIconModal: true })}>
                                                                                {'Select Icon'}
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {/* <Field
                                                                    idToSet="IconResourceObject"
                                                                    name="IconResourceObject"
                                                                    label="Icon Resource Name"
                                                                    maxLength={20}
                                                                    selected={this.state.optionIconsSelected? this.state.optionIconsSelected : { name: '' }}
                                                                    onChangeHandler={(event, newItem) => this.IconResourceNameComponentOnChangeHandler(event,newItem)}
                                                                    optionsItemsIconsData={this.props.IconsData? this.props.IconsData : []}
                                                                    open={this.state.openIconResourceNameSelect? this.state.openIconResourceNameSelect : false}
                                                                    onClick={this.handleCategoryCombo}
                                                                    onBlur={this.onBlurIconResourceNameComponentHandler}
                                                                    component={renderThumbnailSelect}
                                                                /> */}
                                                                </Grid>
                                                                {
                                                                    (this.state && this.state.optionIconsSelected && this.state.optionIconsSelected.name && this.state.optionIconsSelected.name.length > 0) ?
                                                                        <Grid item container style={{ width: '100%' }}>
                                                                            <Field
                                                                                name="detailIconUrl"
                                                                                label="Icon Url"
                                                                                maxLength={20}
                                                                                disabled={true}
                                                                                component={renderTextField}
                                                                            />
                                                                        </Grid>
                                                                        :
                                                                        <Grid item></Grid>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </TabPanel>
                                                {/******************************************************** TabPanel Apps **************************************************************/}
                                                <TabPanel id='groupModal_Enable' className='setupInfoSection' value={this.state.activeStep} index={1} dir={'x'} style={{ height: (Height * .6) + 'px', }}>
                                                    <Grid container justify='flex-start' style={{ position: 'static', overflow: 'auto' }}>
                                                        <this.DnD baseName='enabled' enabledApps={'enabled'} />
                                                    </Grid>
                                                </TabPanel>
                                                {/******************************************************** TabPanel Apps **************************************************************/}
                                                <TabPanel id='groupModal_Disable' className='setupInfoSection' value={this.state.activeStep} index={2} dir={'x'} style={{ height: (Height * .6) + 'px', }}>
                                                    <Grid item container justify='flex-start'  >
                                                        <this.DnD baseName='disabled' enabledApps={'disabled'} />
                                                    </Grid>
                                                </TabPanel>
                                            </SwipeableViews>
                                        </Grid>
                                        <Grid item container justify='flex-end' alignContent='center' style={{ height: ((Height * .15)) + 'px', }}>
                                            <Grid item style={{ display: 'fex', marginTop: 'auto', marginBottom: 'auto' }}>
                                                <Button id='appDetails_cancel_btn' style={{ ...styles.buttonStyle, margin: '0 10px' }} onClick={() => this.closeModal()}>
                                                    Cancel
                                                </Button>
                                            </Grid>
                                            <Grid item style={{ display: 'fex', marginTop: 'auto', marginBottom: 'auto' }}>
                                                <Button id='appDetails_save_btn' style={{ ...styles.buttonStyle, backgroundColor: '#009edd', margin: '0px 10px' }} onClick={handleSubmit(this.onSubmitHandler.bind(this))} >
                                                    {
                                                        (this.state && this.state.elementForDetail && this.state.elementForDetail._id) ? 'Save' : 'Add'
                                                    }
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Modal>

                            :
                            <Grid item container ></Grid>
                    }
                    {
                        this.state.openSelectIconModal === true ?

                            <IconsModal
                                icons={this.props.IconsData}
                                onSelectIcon={this.handleSelectIcon}
                                iconSelected={this.state.optionIconsSelected}
                                onClose={() => { this.setState({ openSelectIconModal: false }) }}
                            />
                            :
                            undefined
                    }
                </form>
            </Grid>

        )
    }
};

function mapStateToProps(state, ownProps) {
    const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

    let groupsAppsData = (state.groupsAppsReducer && state.groupsAppsReducer.groupsAppsData) ? [...state.groupsAppsReducer.groupsAppsData] : [];
    let appsData = (state.appsReducer && state.appsReducer.appsData) ? [...state.appsReducer.appsData] : [];
    const communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData : undefined
    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData) ? state.categoryReducer.IconsData : [];
    const communitySelected = ownProps.communitySelected;
    let newGroupsAppData = [];


    let ArrayData = _.cloneDeep(appsData);
    for (let i = 0; i < ArrayData.length; i++) {
        let currentApp = ArrayData[i];

        if (currentApp && currentApp.appCommunities) {
            currentApp.appCommunities = [...currentApp.appCommunities];
        }
    }
    let newAppsData = [];

    const communityFound = communityData.find(community => community.communityId === communityId);

    for (let i = 0; i < ArrayData.length; i++) {
        let app = ArrayData[i];
        let appCommunities = app.appCommunities;

        if (appCommunities) {
            appCommunities = appCommunities.filter(community => community.communityId === communityId);
            let commObject = appCommunities.find(community => community.communityId === communityId);
            if (commObject) {
                commObject.active = false;
            }
        }

        if (!appCommunities || !appCommunities.length > 0) {
            if (communityId && communityFound) {
                appCommunities = [{
                    active: false,
                    appOrder: 0,
                    appResidents: [],
                    communityId: communityFound._id,
                    communityName: communityFound.communityName
                }];
            }
        }

        app.order = undefined;
        app.appCommunities = appCommunities;

        if (appCommunities && appCommunities[0] && appCommunities[0].appOrder) {
            app.order = appCommunities[0].appOrder;
        }

        newAppsData.push(app);
    }



    for (let i = 0; i < groupsAppsData.length; i++) {
        let currentGroup = _.cloneDeep(groupsAppsData[i]);
        let currentGroupCommunities = currentGroup.groupCommunities;

        if (currentGroupCommunities && currentGroupCommunities.length > 0) {
            currentGroupCommunities = currentGroupCommunities.filter(item => item.communityId === communityId);

            if (!currentGroupCommunities || currentGroupCommunities.length === 0) {
                currentGroupCommunities = [{
                    communityId: communityId,
                    communityName: communitySelected.communityName,
                    apps: [],
                    active: false,
                }]
            }
        }

        currentGroup.groupCommunities = currentGroupCommunities;

        newGroupsAppData.push(currentGroup);
    }

    newAppsData = newAppsData.sort((a, b) => a.order > b.order);

    newGroupsAppData = newGroupsAppData.sort((a, b) => {
        if (!a.groupCommunities || a.groupCommunities.length === 0) return -1;

        const communityA = a.groupCommunities.find(comm => comm.communityId === communityId);
        const communityB = b.groupCommunities.find(comm => comm.communityId === communityId);

        if (!communityA || !communityB) return -1

        return communityA.groupOrder > communityB.groupOrder ? 1 : -1;
    })

    return {
        IconsData: IconsData,
        groupsData: groupsAppsData,
        newGroupsAppData: newGroupsAppData,
        appsData: appsData,
        newAppsData: newAppsData,
        //IconsData: thumbnailIconData,
        communityData: communityData,
        communitySelected: communitySelected,
    };
}

export default connect(mapStateToProps, { GetApps, GetGroups, AddGroup, UpdateGroup, UpdateGroupsOrder, SetHeaderButtons })(reduxForm({
    form: 'AppGroupsForm',
    validate,
    enableReinitialize: true,
})(AppsGroups));

